/**
 * Route shell only. The screen is @alight/enrolment-ui, shared with apps/site
 * — one implementation, two databases (docs/HTBH-MIGRATION.md §8a).
 */
import { createFileRoute } from "@tanstack/react-router";
import { PaymentStatus, type PaymentStatus as PaymentStatusT } from "@alight/contracts";
import { AdminReconciliation } from "@alight/enrolment-ui";

export const Route = createFileRoute("/admin/reconciliation")({
  validateSearch: (search: Record<string, unknown>): { status: PaymentStatusT; ref?: string } => {
    const parsed = PaymentStatus.safeParse(search.status);
    const ref =
      typeof search.ref === "string" && search.ref.trim() !== ""
        ? search.ref.trim().toUpperCase()
        : undefined;
    return { status: parsed.success ? parsed.data : "pending_review", ref };
  },
  component: AdminReconciliation,
});
